import React, { Component } from 'react'
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import Scream from "../components/scream/Scream";
import Profile from "../components/profile/Profile";
import { connect } from "react-redux";
import { getScreams } from "../redux/actions/dataActions";
import ScreamSkeleton from "../utils/ScreamSkeleton";

export class home extends Component {

    componentDidMount() {
        this.props.getScreams();
    };

    render() {
        const { screams, loading } = this.props.data;
        let recentScreams = !loading ? (
            screams.map((scream, i) => <Scream key={scream.screamId} scream={scream}/>)
        ) : (
            <ScreamSkeleton />
        )

        return (
            <Grid container spacing={3}>
                <Grid item sm={4} xs={12}>
                    <Profile />
                </Grid>
                <Grid item sm={8} xs={12}>
                    {recentScreams}
                </Grid>
            </Grid>
        )
    }
}

home.propTypes = {
    getScreams: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    data: state.data
});

export default connect(mapStateToProps, { getScreams })(home);